export const PREFIX_CLS = 'idoll-fullcalendar';
